import * as Sentry from '@sentry/react';

interface CaptureErrorParams {
  error: unknown; // O erro a ser capturado, deve ser uma instância de Error
  payload?: any; // Dados adicionais que você pode querer enviar com o erro
  module?: string; // Nome do módulo onde o erro ocorreu
  url?: string; // URL onde o erro ocorreu
  method?: 'GET' | 'POST' | 'PUT' | 'PACTH' | 'DELETE' | string; // Método HTTP (caso aplicável)
  level?: 'fatal' | 'error' | 'warning' | 'info' | 'debug'; // Nível do erro
}

export const captureError = ({
  error,
  payload,
  module = 'defaultModule',
  url,
  method,
  level = 'error',
}: CaptureErrorParams): void => {
  Sentry.captureException(error, {
    tags: {
      module,
    },
    extra: {
      payload,
    },
    level,
    contexts: {
      request: {
        url,
        method,
      },
    },
  });
};
